import { render, staticRenderFns } from "./service-index.vue?vue&type=template&id=658633c0&"
import script from "./service-index.vue?vue&type=script&lang=js&"
export * from "./service-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports